import React, { useEffect, useState } from "react";
import { InputGroup, FormControl, Button } from "react-bootstrap";
import InputGroupControl from "../../Common/InputGroup";
import { capitalizeString } from "../../../actions/common";
import { checkGitchaAvailable, getGeoLocation } from "../../../services/commonServices";
import { getLocalStorage, getUserId, removeLocalStorage, setLocalStorage } from "../../../helpers/common";

const FilterLocationSearch = (props) => {
const {setUserLocation, key, isClearFilter, gitchaNotAvailble, searchedLocation, handleGitchaNotAvailableLocation} = props
const [locationList, setLocationList] = useState([]);
// const [city, setCity] = useState("")
// const [state, setState] = useState("")
const [lat, setLat] = useState("")
const [long, setLong] = useState("")
const [location, setLocation] = useState("")
const [formattedAddress, setFormattedAddress] = useState(_.get(searchedLocation,"formatted_address", ""))
const userLocation = getLocalStorage("userLocation");
const locationString = getLocalStorage("LocationString");
const userId = getUserId();
useEffect(()=>{
if(locationString != null && userId ){
  const reqPayload = `address=${capitalizeString(locationString)}&components=country:US`;
  getAddresseDetails({ reqPayload: reqPayload });
}
else {
  if(!searchedLocation){
    clearLocationStates()
  }
  else{
    setLat(_.get(searchedLocation,"latitude", ""))
    setLong(_.get(searchedLocation,"longitude", ""))
    setLocation(_.get(searchedLocation,"formatted_address", ""))
  }
}
}, [searchedLocation, gitchaNotAvailble, locationString, userId])
const clearAddressList = () => {
  setLocationList([]);
};

const handleLocationChange = (val) => { 
  const value = capitalizeString(val);
  const reqPayload = `address=${value}&components=country:US`;
  if (value.trim() !== "") {
    getAddresseDetails({ reqPayload: reqPayload });
  } else {
    clearAddressList();
  }
  if (value && value.trim() !== "") {
    setLocation(value);
} else {
    clearLocationStates();
  } 
  // else {
  //   clearLocationStates();
  // }
};

const clearLocationStates = () => {
//  setCity(_.get(userLocation, "userCity", ""));
//  setState(_.get(userLocation, "state", ""))  
if(!locationString){
  removeLocalStorage("searchedLocation")
  if(gitchaNotAvailble){
    setUserLocation(null)  
  }
  else {
      setLat(_.get(userLocation, "latitude", null))
      setLong(_.get(userLocation, "longitude", null))
      setFormattedAddress(_.get(userLocation, "formatted_address", null))
      setUserLocation(userLocation)
    }
  setLocation("")
  }
};


const getAddresseDetails = async ({ eventType, reqPayload }) => {
  await getGeoLocation(reqPayload).then((data) => {
    const results = _.get(data, "results");
    if (results?.length > 0) {
      const formatted_address = _.get(results?.[0], 'formatted_address', '')
        if(results?.length > 0 && formatted_address!== "United States"){
          if(locationString){
            handleItemSelection(results[0]);
            removeLocalStorage("LocationString")
          }
          else {
            setLocationList(results);
          }
        }
    } 
  });
};

const handleItemSelection = async (address) => {
  let city, state, county;
  removeLocalStorage("searchedLocation")
  const geometry = _.get(address, "geometry", "");
  const locBounds = _.get(geometry, "location", "");
  setLat(_.get(locBounds, "lat", ""))
  setLong(_.get(locBounds, "lng", ""))
  const formatted_address = _.get(address, "formatted_address", "");
  const firstAddressComponent = _.get(address, "address_components", "");
  const stateSearched = firstAddressComponent.filter(function (ca) {
    return ca.types?.[0] === "administrative_area_level_1";
  });
  if (stateSearched.length) {
     state = _.get(stateSearched?.[0], "short_name", "");
  }
  const locality = firstAddressComponent.filter(function (ca) {
    return ca.types?.[0] === "locality";
  });
  if (locality.length) {
     city = _.get(locality?.[0], "long_name", "");
  }
  const countyList = firstAddressComponent.filter(function (ca) {
    return ca.types?.[0] === "administrative_area_level_2";
  });

  if (countyList.length) {
    county = _.get(countyList?.[0], "short_name", "");
  }
  if(city!= undefined){setFormattedAddress(city+", "+state)}
  else{setFormattedAddress(formatted_address)}
  setLocation(city!=undefined ? city+", "+state : formatted_address);  
  const locationObject = {latitude:_.get(locBounds, "lat", ""), longitude:_.get(locBounds, "lng", ""), formatted_address:city!=undefined ? city+", "+state : formatted_address}
  checkGitchaAvailableInLoc(city, state, county,formatted_address, locationObject);
  // setLocalStorage("searchedLocation", {latitude:_.get(locBounds, "lat", ""), longitude:_.get(locBounds, "lng", ""), formatted_address:city!=undefined ? city+", "+state : formatted_address})
  // setUserLocation({latitude:_.get(locBounds, "lat", ""), longitude:_.get(locBounds, "lng", ""), formatted_address:city!=undefined ? city+", "+state : formatted_address})
  clearAddressList();
};

const checkGitchaAvailableInLoc = async (city,state, county,formatted_address, locationObject) => {
  const reqPayLoad = {
    county : county,
    state : state
  }
  await checkGitchaAvailable(reqPayLoad).then((data) => {
    if(_.get(data, "result")== true){
      setLocalStorage("searchedLocation", locationObject);
      setUserLocation(locationObject);
    }
    else {      
        handleGitchaNotAvailableLocation({city: city, state :state, county: county, formatted_Address: formatted_address});
        setLocation("")
    }        
  }) 
}

  return (
    // <InputGroup className="search_field">
    <>
    <div className="position-relative">
      {locationList.length > 0 ? (
                    <Button
                      variant=""
                      className="search-clear-btn"
                      onClick={() => clearAddressList()}
                    ></Button>
                  ) : (
                    ""
                  )}
                  <InputGroupControl
                    inputGroupClass="wantad-location-search position-relative"
                    ariaLabel="Example"
                    ariaDescribedBy="basic-addon3"
                    placeholder="Enter zip code or city and state"
                    errorMessage=""
                    value={location ? location : ""}
                    iconClass="location-icon"
                    isIconEnable={true}
                    iconId="button-addon3"
                    onChange={(e) => {
                      handleLocationChange(e.target.value);
                    }}
                  />
                  {locationList.length > 0 ? (
                    <div className="location-result-wrap">
                      <ul>
                        {locationList?.map((address, i) => {
                          return (
                            <li key={i}>
                              <a
                                role="button"
                                href={void 0}
                                onClick={(e) => {
                                  handleItemSelection(address);
                                }}
                              >
                                {_.get(address, "formatted_address", "")}
                              </a>
                            </li>
                          );
                        })}
                      </ul>
                    </div>
                  ) : (
                    ""
                  )}

      {/* <Button className="location-icn" variant="secondary" id="button-addon2">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.25 8C11.0074 8 10 9.00736 10 10.25C10 11.4926 11.0074 12.5 12.25 12.5C13.4926 12.5 14.5 11.4926 14.5 10.25C14.5 9.00736 13.4926 8 12.25 8ZM8.5 10.25C8.5 8.17893 10.1789 6.5 12.25 6.5C14.3211 6.5 16 8.17893 16 10.25C16 12.3211 14.3211 14 12.25 14C10.1789 14 8.5 12.3211 8.5 10.25Z"
            fill="#6A768F"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.25 3.5C10.4598 3.5 8.7429 4.21116 7.47703 5.47703C6.21116 6.7429 5.5 8.45979 5.5 10.25C5.5 13.355 7.23389 16.1822 9.06595 18.2891C9.97283 19.332 10.8816 20.1729 11.5639 20.7528C11.8337 20.9821 12.0672 21.1699 12.25 21.3125C12.4328 21.1699 12.6663 20.9821 12.9361 20.7528C13.6184 20.1729 14.5272 19.332 15.434 18.2891C17.2661 16.1822 19 13.355 19 10.25C19 8.45979 18.2888 6.7429 17.023 5.47703C15.7571 4.21116 14.0402 3.5 12.25 3.5ZM12.25 22.25C11.8199 22.8644 11.8197 22.8643 11.8195 22.8641L11.8188 22.8637L11.8171 22.8624L11.8115 22.8585L11.7925 22.845C11.7763 22.8334 11.7531 22.8167 11.7236 22.7952C11.6644 22.752 11.5794 22.689 11.4723 22.6071C11.2581 22.4434 10.9549 22.2038 10.5924 21.8957C9.86838 21.2803 8.90217 20.3867 7.93405 19.2734C6.01611 17.0678 4 13.895 4 10.25C4 8.06196 4.86919 5.96354 6.41637 4.41637C7.96354 2.86919 10.062 2 12.25 2C14.438 2 16.5365 2.86919 18.0836 4.41637C19.6308 5.96354 20.5 8.06196 20.5 10.25C20.5 13.895 18.4839 17.0678 16.566 19.2734C15.5978 20.3867 14.6316 21.2803 13.9076 21.8957C13.5451 22.2038 13.2419 22.4434 13.0277 22.6071C12.9206 22.689 12.8356 22.752 12.7764 22.7952C12.7469 22.8167 12.7237 22.8334 12.7075 22.845L12.6885 22.8585L12.6829 22.8624L12.6812 22.8637L12.6805 22.8641C12.6803 22.8643 12.6801 22.8644 12.25 22.25ZM12.25 22.25L12.6805 22.8641C12.4223 23.0449 12.0777 23.0449 11.8195 22.8641L12.25 22.25Z"
            fill="#6A768F"
          />
        </svg>
      </Button> */}
    {/* </InputGroup> */}
    </div>
    </>
  );
};
export default FilterLocationSearch;
